export default {
  'start': [
    require('./assets/svg/scene__layer--ground.svg'),
    require('./assets/svg/intro/foreground.svg'),
    require('./assets/svg/intro/midground.svg'),
    require('./assets/svg/intro/background.svg'),
    require('./assets/svg/intro/cyclist.svg'),
    require('./assets/svg/intro/cyclist--small.svg'),
    require('./assets/svg/intro/flag.svg'),
    require('./assets/svg/intro/flag--small.svg'),
    require('./assets/svg/intro/schoolboy.svg'),
    require('./assets/svg/intro/schoolboy--small.svg'),
    require('./assets/svg/intro/turbine.svg')
  ],
  'intro': [
    require('./assets/svg/scene__layer--ground.svg'),
    require('./assets/svg/intro/foreground.svg'),
    require('./assets/svg/intro/midground.svg'),
    require('./assets/svg/intro/background.svg'),
    require('./assets/svg/intro/cyclist.svg'),
    require('./assets/svg/intro/cyclist--small.svg'),
    require('./assets/svg/intro/flag.svg'),
    require('./assets/svg/intro/flag--small.svg'),
    require('./assets/svg/intro/schoolboy.svg'),
    require('./assets/svg/intro/schoolboy--small.svg'),
    require('./assets/svg/intro/turbine.svg')
  ],
  'school-grounds': [
    require('./assets/svg/school-grounds/foreground.svg'),
    require('./assets/svg/school-grounds/midground.svg'),
    require('./assets/svg/school-grounds/background.svg'),
    require('./assets/svg/school-grounds/birdhouse.svg'),
    require('./assets/svg/school-grounds/birdhouse--small.svg'),
    require('./assets/svg/school-grounds/butterflies-left.svg'),
    require('./assets/svg/school-grounds/butterflies-left--small.svg'),
    require('./assets/svg/school-grounds/butterflies-right.svg'),
    require('./assets/svg/school-grounds/butterflies-right--small.svg'),
    require('./assets/svg/school-grounds/pupil.svg'),
    require('./assets/svg/school-grounds/pupil--small.svg')
  ],
  'classroom': [
    require('./assets/svg/classroom/foreground.svg'),
    require('./assets/svg/classroom/midground.svg'),
    require('./assets/svg/classroom/background.svg'),
    require('./assets/svg/classroom/teacher.svg'),
    require('./assets/svg/classroom/teacher--small.svg'),
    require('./assets/svg/classroom/pupil.svg'),
    require('./assets/svg/classroom/pupil--small.svg'),
    require('./assets/svg/classroom/clock.svg')
  ],
  'corridor': [
    require('./assets/svg/corridor/foreground.svg'),
    require('./assets/svg/corridor/midground.svg'),
    require('./assets/svg/corridor/background.svg'),
    require('./assets/svg/corridor/watertank.svg'),
    require('./assets/svg/corridor/watertank--small.svg'),
    require('./assets/svg/corridor/pupil.svg'),
    require('./assets/svg/corridor/pupil--small.svg'),
    require('./assets/svg/corridor/noticeboard.svg'),
    require('./assets/svg/corridor/noticeboard--small.svg')
  ],
  'bathroom': [
    require('./assets/svg/bathroom/foreground.svg'),
    require('./assets/svg/bathroom/background.svg'),
    require('./assets/svg/bathroom/dryer.svg'),
    require('./assets/svg/bathroom/dryer--small.svg'),
    require('./assets/svg/bathroom/door.svg'),
    require('./assets/svg/bathroom/door--small.svg'),
    require('./assets/svg/bathroom/girl.svg'),
    require('./assets/svg/bathroom/girl--small.svg')
  ],
  'school-hall': [
    require('./assets/svg/school-hall/foreground.svg'),
    require('./assets/svg/school-hall/midground.svg'),
    require('./assets/svg/school-hall/girl.svg'),
    require('./assets/svg/school-hall/girl--small.svg'),
    require('./assets/svg/school-hall/boy-waving.svg'),
    require('./assets/svg/school-hall/boy-waving--small.svg'),
    require('./assets/svg/school-hall/piano-player.svg'),
    require('./assets/svg/school-hall/piano-player--small.svg'),
    require('./assets/svg/school-hall/piano.svg')
  ],
  'canteen': [
    require('./assets/svg/canteen/foreground.svg'),
    require('./assets/svg/canteen/midground.svg'),
    require('./assets/svg/canteen/background.svg'),
    require('./assets/svg/canteen/lady.svg'),
    require('./assets/svg/canteen/lady--small.svg'),
    require('./assets/svg/canteen/pupil-plate.svg'),
    require('./assets/svg/canteen/pupil-plate--small.svg'),
    require('./assets/svg/canteen/pupil-drinking.svg'),
    require('./assets/svg/canteen/pupil-drinking--small.svg')
  ]
}



// WEBPACK FOOTER //
// ./src/manifest.js